import styled from "@emotion/styled";
import MenuItem from "@mui/material/MenuItem";

import { fontRoboto, theme } from "shared/lib/styles";

export const Container = styled.div`
  inline-size: 100%;
  padding-inline: 20px;

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const StyledSelectContainer = styled.div`
  inline-size: 100%;
  max-inline-size: 480px;
  margin-inline: auto;
  & .MuiSelect-root {
    inline-size: 100%;
    & .MuiSelect-select {
      min-block-size: auto;
      padding-block: 8px;
      padding-inline: 12px;

      color: #666666;
      font-size: 16px;
      font-family: ${fontRoboto};
      letter-spacing: 0.19px;
    }

    & .Mui-focused.MuiOutlinedInput-notchedOutline,
    .MuiOutlinedInput-notchedOutline {
      border-color: #d7d7d7;
      border-width: 1px;
      border-radius: 2px;
    }
  }
`;

type StyledMenuItemProps = {
  $isSelected: boolean;
};
export const StyledMenuItem = styled(MenuItem)<StyledMenuItemProps>`
  &.MuiButtonBase-root {
    min-block-size: auto;
    padding-block: 9px;
    padding-inline: 12px;

    color: ${props => (props.$isSelected ? "#000" : "#666")};
    font-size: 16px;
    font-family: ${fontRoboto};
    line-height: 19px;

    background-color: #ffffff;

    &.Mui-selected,
    &:hover {
      color: #000000;

      background-color: #ffffff;
    }
  }
`;
